var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.892 6.944a6.637 6.637 0 00-12.47 4.438 4.54 4.54 0 00-1.978 8.567",
    stroke: "#2C2D2E",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.348 12.778h-1.222a2.794 2.794 0 00-2.794 2.793v6.636A2.794 2.794 0 0013.126 25h9.08A2.794 2.794 0 0025 22.207V15.57a2.794 2.794 0 00-2.794-2.793h-1.222M17.841 11.206v9.389",
    stroke: "#2C2D2E",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.698 18.19l3.143 2.445 3.143-2.444",
    stroke: "#2C2D2E",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5Ljg5MjMgNi45NDM1MkMxOC44NjAxIDQuNjE5NjYgMTYuNTMxOSAyLjk5OTAyIDEzLjgyNTIgMi45OTkwMkMxMC4xNjA2IDIuOTk5MDIgNy4xODk4MiA1Ljk2OTggNy4xODk4MiA5LjYzNDQ1QzcuMTg5ODIgMTAuMjM5MyA3LjI3MDc1IDEwLjgyNTMgNy40MjIzNyAxMS4zODIxQzQuOTY4OTEgMTEuNDQ0IDIuOTk5MDIgMTMuNDUyMyAyLjk5OTAyIDE1LjkyMDZDMi45OTkwMiAxNy42NzIyIDMuOTkwOTIgMTkuMTkyMSA1LjQ0MzY1IDE5Ljk0OTIiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIxLjkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuMzQ4MiAxMi43Nzc2SDEzLjEyNTlDMTEuNTgyOSAxMi43Nzc2IDEwLjMzMiAxNC4wMjg0IDEwLjMzMiAxNS41NzE0TDEwLjMzMiAyMi4yMDY5QzEwLjMzMiAyMy43NDk5IDExLjU4MjkgMjUuMDAwNyAxMy4xMjU5IDI1LjAwMDdIMjIuMjA1OUMyMy43NDg5IDI1LjAwMDcgMjQuOTk5OCAyMy43NDk5IDI0Ljk5OTggMjIuMjA2OVYxNS41NzE0QzI0Ljk5OTggMTQuMDI4NCAyMy43NDg5IDEyLjc3NzYgMjIuMjA1OSAxMi43Nzc2SDIwLjk4MzYiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIxLjkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuODQxMyAxMS4yMDU5VjIwLjU5NDkiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIxLjkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuNjk4MiAxOC4xOTA2TDE3Ljg0MTMgMjAuNjM1MkwyMC45ODQ0IDE4LjE5MDYiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIxLjkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgClone as ReactComponent };